

import "../../../Foundation/stylable/colors.st.css.js";
import "../../../Foundation/stylable/shadows.st.css.js";
import { classesRuntime, statesRuntime } from "./../../../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_PopoverNextContent";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_PopoverNextContent__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-popover-border-radius":"--wds-popover-border-radius","wds-shadow-surface-overlay":"--wds-shadow-surface-overlay","wds-color-fill-surface-overlay":"--wds-color-fill-surface-overlay","wds-color-text-standard-primary":"--wds-color-text-standard-primary","wds-font-size-body-small":"--wds-font-size-body-small","wds-font-line-height-body-small":"--wds-font-line-height-body-small","wds-color-text-standard-primary-light":"--wds-color-text-standard-primary-light","wds-color-fill-surface-overlay-dark":"--wds-color-fill-surface-overlay-dark","wds-popover-border-width":"--wds-popover-border-width","wds-popover-border-fill":"--wds-popover-border-fill","wds-popover-fill":"--wds-popover-fill"}; 




